// extracted by mini-css-extract-plugin
module.exports = {"budget":"BudgetLinks_budget__c2nct"};